import React from 'react'
import cx from 'classnames'

import Image from '@/image.js'

class EventHero extends React.Component {
  constructor() {
    super()
    this.state = {
      visible: false
    }
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({
        visible: true
      })
    }, 1000)
  }
  render() {
    const {
      title,
      subDescription,
      imageId,
      supportingImageId
    } = this.props
    return (
      <div className={cx('events__hero rel container--xl mxa', {
          'is-animated': this.state.visible
        })}>
        <div className=' mxa p15 f jcb'>
          <div className='container--m events__hero-title'>
            <h2 className='animate mt0 a-o a-t'>{title}</h2>
          </div>
        </div>
        <div className='x f jcb fw events__hero-flex pb15 mb15'>
          <div className='x f jcb events__hero-upcoming animate a-o a-t a-d-2'>
            <Image imageId={imageId} alt={title} />
          </div>
          <div className='px15'>
            <p className='s22 py15 animate a-t- a-d-6 a-o'>{subDescription}</p>
            <Image className='animate a-o a-t a-d-4' imageId={supportingImageId} alt={title} />
            <div className='px15 pb15 ac mt15 events__outlines events__hero-outlines'>
              <h3 className='caps m0 p0 medium animate a-o a-t a-d-2 outline o2'>UPCOMING EVENTS</h3>
              <h3 className='caps m0 p0 medium animate a-o a-t a-d-4 outline o5'>UPCOMING EVENTS</h3>
              <h3 className='caps m0 p0 medium animate a-o a-t a-d-6 outline black'>UPCOMING EVENTS</h3>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EventHero